import { ArrayHelpers, Paging, SystemText } from '@salesperformanceint/e4shared';
import { hasAccelerateOrChallenger } from 'helpers/company';
import React from 'react';
import { useSelector } from 'react-redux';
import Modules from './components/modules';
import Affected from './components/affected';

export const BehaviourTable = ({ data, widget }) => {
    const [page, setPage] = React.useState(1);
    const [sortBy, setSortBy] = React.useState('area');
    const [descending, setDescending] = React.useState(false);
    const [sortedData, setSortedData] = React.useState([]);
    const [showModules, setShowModules] = React.useState(null);
    const [showUsers, setShowUsers] = React.useState(null);
    const pageSize = 10;

    const { user } = useSelector(state => state.user);

    const hasInternalLMS = hasAccelerateOrChallenger(user);

    React.useEffect(() => {
        const n = descending ? -1 : 1;

        const sorter = (x, s) => `${x[s]}-${100 - x.impacted}`;
        const temp = [...data].sort((a, b) => (sorter(a, sortBy) > sorter(b, sortBy) ? 1 * n : -1 * n));
        setSortedData(ArrayHelpers.getPage(temp, page, pageSize));
    }, [data, page, sortBy, descending]);

    React.useEffect(() => {
        setPage(1);
    }, [sortBy, descending]);

    const ordering = ref => {
        return ref === sortBy ? (
            <span className="ml5">
                <i className={`fa fa-caret-${descending ? 'down' : 'up'}`} />
            </span>
        ) : null;
    };

    const th = (label, ref, alignRight) => {
        return (
            <th className={alignRight ? 'text-right' : ''}>
                <span
                    className="pointer bold"
                    onClick={() => {
                        setDescending(ref === sortBy ? !descending : false);
                        setSortBy(ref);
                    }}
                >
                    {label}
                    {ordering(ref)}
                </span>
            </th>
        );
    };

    const tableFooter =
        data.length > pageSize ? (
            <div className="text-left mt10 pt5">
                <Paging goToPage={page => setPage(page)} pageSize={pageSize} recordCount={data.length} page={page} />
            </div>
        ) : null;

    const labelClass = x => {
        if (x >= 67) return 'danger-light';
        if (x >= 34) return 'warning-light';
        return 'success-light';
    };

    return (
        <div>
            <div className="table-responsive table-match-left">
                <table className="table table-hover mb10">
                    <thead>
                        <tr>
                            {th(SystemText('Dashboard/Widgets/ActionPlanner/Table/Columns/Capability'), 'area')}
                            {th(SystemText('Dashboard/Widgets/ActionPlanner/Table/Columns/Behavior'), 'name')}
                            {th(SystemText('Dashboard/Widgets/ActionPlanner/Table/Columns/Impact'), 'impacted')}
                            {th(SystemText('Dashboard/Widgets/ActionPlanner/Table/Columns/Manager'), 'manager')}
                            {th(SystemText('Dashboard/Widgets/ActionPlanner/Table/Columns/User'), 'seller')}
                            {hasInternalLMS &&
                                th(SystemText('Dashboard/Widgets/ActionPlanner/Table/Columns/Content'), 'content')}
                        </tr>
                    </thead>
                    <tbody>
                        {data.length === 0 && (
                            <tr>
                                <td colSpan={9} className="td-no-results">
                                    {SystemText('Dashboard/Widgets/ActionPlanner/Table/NoResults')}
                                </td>
                            </tr>
                        )}
                        {sortedData.map((row, i) => {
                            return (
                                <tr key={`${row.id}`} data-task-id={row.id}>
                                    <td>{row.area}</td>
                                    <td>{row.name}</td>
                                    <td className="text-center">
                                        <button className="btn btn-link" onClick={() => setShowUsers(row)}>
                                            <label className={`pointer label label-${labelClass(row.impacted)}`}>
                                                {row.impacted}%<i className="ml5 fa fa-users" />
                                            </label>
                                        </button>
                                    </td>
                                    <td className="text-center">{row.manager.toFixed(1)}</td>
                                    <td className="text-center">{row.seller.toFixed(1)}</td>
                                    {hasInternalLMS && (
                                        <>
                                            {row.content === 1 ? (
                                                <td className="no-wrap">
                                                    <button className="btn btn-link" onClick={() => setShowModules(row)}>
                                                        {SystemText(
                                                            'Dashboard/Widgets/ActionPlanner/Table/Columns/Content/OneData'
                                                        )}
                                                    </button>
                                                </td>
                                            ) : row.content > 1 ? (
                                                <td className="no-wrap">
                                                    <button className="btn btn-link" onClick={() => setShowModules(row)}>
                                                        {SystemText(
                                                            'Dashboard/Widgets/ActionPlanner/Table/Columns/Content/Data',
                                                            row.content
                                                        )}
                                                    </button>
                                                </td>
                                            ) : (
                                                <td className="no-wrap" style={{ color: '#8C81A1' }}>
                                                    {SystemText(
                                                        'Dashboard/Widgets/ActionPlanner/Table/Columns/Content/NoData'
                                                    )}
                                                </td>
                                            )}
                                        </>
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                {tableFooter}
            </div>
            <Affected show={showUsers} widget={widget} onClose={() => setShowUsers(null)} />
            <Modules show={showModules} onClose={() => setShowModules(null)} />
        </div>
    );
};

export default BehaviourTable;
